import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { UpdateStudentForGroupPayload } from "../../payload/UpdateStudentForGroup/UpdateStudentForGroupPayload";

const updateStudentForGroupFetch = (state: GroupsState, action: PayloadAction<UpdateStudentForGroupPayload>) => {
    state.isLoading = true;
}

export default updateStudentForGroupFetch;